import Async from 'react-select/async';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ReactSelectAsync.scss';
import classNames from 'classnames';

class ReactSelectAsync extends Component {
  static propTypes = {
    name: PropTypes.string,
    classNamePrefix: PropTypes.string,
    className: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    noOptionsMessage: PropTypes.func,
    isDisabled: PropTypes.bool,
    loadOptions: PropTypes.func,
    styles: PropTypes.object,
    onKeyDown: PropTypes.func,
    autoFocus: PropTypes.bool,
    place: PropTypes.string
  };

  static defaultProps = {
    classNamePrefix: 'react-select'
  };

  render() {
    const { className } = this.props;

    const cardClass = classNames({
      'react-select': true,
      [className]: !!className
    });

    const props = { ...this.props, className: cardClass };

    return <Async {...props} />;
  }
}

export default ReactSelectAsync;
